import React, { useState, useContext } from 'react';
import MasterLayout from '../layouts/masterlayout';
import SuccessMessage from '../common/successmessage';
import ErrorMessage from '../common/errormessage';
import GeneralButton from '../common/button_general';
import GeneralTextBox from '../common/textboxes/textbox_general';
import { changeUserPassword, updateUserEmail } from '../../lib/cognitoutils';
import { UserContext } from '../../lib/usercontext';

const AccountSettings = () => {
  const { user, setUser } = useContext(UserContext);

  /* ---------- password ---------- */
  const [currentPwd, setCurrentPwd] = useState('');
  const [newPwd, setNewPwd] = useState('');
  const [confirmPwd, setConfirmPwd] = useState('');

  /* ---------- email ------------- */
  const [newEmail, setNewEmail]     = useState(user.email || '');
  const [confirmEmail, setConfirmEmail] = useState('');

  /* ---------- feedback ---------- */
  const [success, setSuccess] = useState('');
  const [error,   setError]   = useState('');

  const resetMessages = () => { setSuccess(''); setError(''); };

  const handlePasswordSave = async (e) => {
    e.preventDefault();
    resetMessages();
    if (newPwd !== confirmPwd) { setError('Passwords do not match'); return; }
    try {
      await changeUserPassword(currentPwd, newPwd);      // util must return a promise
      setSuccess('Password updated successfully');
      setCurrentPwd(''); setNewPwd(''); setConfirmPwd('');
    } catch (err) {
      setError(err.message || 'Password update failed');
    }
  };

  const handleEmailSave = async (e) => {
    e.preventDefault();
    resetMessages();
    if (newEmail !== confirmEmail) { setError('Emails do not match'); return; }
    try {
      await updateUserEmail(newEmail);                   // util must return a promise
      setUser({ ...user, email: newEmail });
      setSuccess('Email updated successfully');
      setConfirmEmail('');
    } catch (err) {
      setError(err.message || 'Email update failed');
    }
  };

  return (
    <MasterLayout pageTitle="Account Settings">
      {error   && <ErrorMessage   message={error}   />}
      {success && <SuccessMessage message={success} />}
      <div className="p-4">
      <form onSubmit={handlePasswordSave} className="grid gap-6 mb-10 md:grid-cols-3 max-w-3xl">
        <GeneralTextBox
          label="Current Password" id="currentPwd" name="currentPwd" type="password"
          value={currentPwd} onChange={(e) => setCurrentPwd(e.target.value)} required
        />
        <GeneralTextBox
          label="New Password" id="newPwd" name="newPwd" type="password"
          value={newPwd} onChange={(e) => setNewPwd(e.target.value)} required
        />
        <GeneralTextBox
          label="Confirm New Password" id="confirmPwd" name="confirmPwd" type="password"
          value={confirmPwd} onChange={(e) => setConfirmPwd(e.target.value)} required
        />
        <div className="md:col-span-3 flex justify-center">
          <GeneralButton type="submit" buttonType="primary">Save Password</GeneralButton>
        </div>
      </form>

      <hr className="my-6" />

      <form onSubmit={handleEmailSave} className="grid gap-6 mb-6 md:grid-cols-2 max-w-3xl">
        <GeneralTextBox
          label="New Email" id="newEmail" name="newEmail" type="email"
          value={newEmail} onChange={(e) => setNewEmail(e.target.value)} required
        />
        <GeneralTextBox
          label="Confirm New Email" id="confirmEmail" name="confirmEmail" type="email"
          value={confirmEmail} onChange={(e) => setConfirmEmail(e.target.value)} required
        />
        <div className="md:col-span-2 flex justify-center">
          <GeneralButton type="submit" buttonType="primary">Save Email</GeneralButton>
        </div>
      </form>
        </div>
    </MasterLayout>
  );
};

export default AccountSettings;
